/* Studio's: live openingsstatus, afstand-sortering en mobiele sticky. */
(function () {
  var DAYS = { zo: 0, ma: 1, di: 2, wo: 3, do: 4, vr: 5, za: 6 };
  var DAY_NAMES = ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag'];

  /* "ma-vr=10:00-17:00" per regel; "za=10:00-16:00"; "zo=dicht" */
  function parseHours(raw) {
    var table = {};
    if (!raw) return table;
    raw.split('\n').forEach(function (line) {
      line = line.trim().toLowerCase();
      if (!line || line.indexOf('=') === -1) return;
      var parts = line.split('=');
      var days = parts[0].trim();
      var times = parts[1].trim();
      var from = null, to = null;
      var m = times.match(/(\d{1,2})[:.](\d{2})\s*-\s*(\d{1,2})[:.](\d{2})/);
      if (m) { from = parseInt(m[1], 10) * 60 + parseInt(m[2], 10); to = parseInt(m[3], 10) * 60 + parseInt(m[4], 10); }
      var list = [];
      if (days.indexOf('-') > -1) {
        var d = days.split('-');
        var a = DAYS[d[0].trim()], b = DAYS[d[1].trim()];
        if (a === undefined || b === undefined) return;
        var i = a;
        while (true) { list.push(i); if (i === b) break; i = (i + 1) % 7; }
      } else if (DAYS[days] !== undefined) {
        list = [DAYS[days]];
      }
      list.forEach(function (day) { table[day] = m ? { from: from, to: to } : null; });
    });
    return table;
  }

  function fmt(mins) {
    var h = Math.floor(mins / 60), m = mins % 60;
    return h + ':' + (m < 10 ? '0' + m : m);
  }

  function nowInNL() {
    var p = new Intl.DateTimeFormat('nl-NL', { timeZone: 'Europe/Amsterdam', weekday: 'short', hour: 'numeric', minute: 'numeric', hourCycle: 'h23' }).formatToParts(new Date());
    var out = {};
    p.forEach(function (x) { out[x.type] = x.value; });
    var wd = { 'zo': 0, 'ma': 1, 'di': 2, 'wo': 3, 'do': 4, 'vr': 5, 'za': 6 }[out.weekday.slice(0, 2)];
    return { day: wd, mins: parseInt(out.hour, 10) * 60 + parseInt(out.minute, 10) };
  }

  function status(table) {
    var now = nowInNL();
    var today = table[now.day];
    if (today && now.mins >= today.from && now.mins < today.to) {
      return { open: true, text: 'Nu geopend tot ' + fmt(today.to) };
    }
    if (today && now.mins < today.from) {
      return { open: false, text: 'Gesloten · vandaag open om ' + fmt(today.from) };
    }
    for (var i = 1; i <= 7; i++) {
      var d = (now.day + i) % 7;
      if (table[d]) {
        var label = i === 1 ? 'morgen' : DAY_NAMES[d];
        return { open: false, text: 'Gesloten · ' + label + ' weer open' };
      }
    }
    return { open: false, text: 'Op afspraak' };
  }

  function applyStatus(scope) {
    (scope || document).querySelectorAll('[data-sf-hours]').forEach(function (el) {
      var table = parseHours(el.getAttribute('data-sf-hours'));
      if (!Object.keys(table).length) return;
      var s = status(table);
      if (!s.open && el.hasAttribute('data-sf-hide-closed')) {
        el.style.display = 'none';
        return;
      }
      el.style.display = '';
      el.textContent = s.text;
      el.classList.toggle('open', s.open);
    });
  }

  function haversine(a, b) {
    var R = 6371, rad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * rad, dLng = (b.lng - a.lng) * rad;
    var q = Math.sin(dLat / 2) * Math.sin(dLat / 2) + Math.cos(a.lat * rad) * Math.cos(b.lat * rad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return R * 2 * Math.atan2(Math.sqrt(q), Math.sqrt(1 - q));
  }

  function initOverview() {
    var root = document.querySelector('[data-sf-studios]');
    if (!root) return;
    var grid = root.querySelector('.sf-sto-grid');
    var cards = Array.prototype.slice.call(root.querySelectorAll('.sf-sto-card'));
    var sticky = root.querySelector('.sf-st-sticky');

    function sortByOrigin(origin) {
      cards.forEach(function (card) {
        var lat = parseFloat(card.getAttribute('data-lat'));
        var lng = parseFloat(card.getAttribute('data-lng'));
        if (isNaN(lat) || isNaN(lng)) return;
        var km = Math.round(haversine(origin, { lat: lat, lng: lng }));
        card.setAttribute('data-km', km);
        var d = card.querySelector('.sf-sto-card__distance');
        if (d) d.textContent = km + ' km van jou';
      });
      function sortKey(card) {
        var km = parseFloat(card.getAttribute('data-km'));
        return (isNaN(km) ? 1e9 : km) + (card.hasAttribute('data-soon') ? 1e6 : 0);
      }
      cards.sort(function (a, b) { return sortKey(a) - sortKey(b); });
      cards.forEach(function (card, i) {
        grid.appendChild(card);
        card.classList.toggle('compact', window.matchMedia('(max-width: 749px)').matches && i > 0);
      });
      fillSticky();
    }

    function fillSticky() {
      if (!sticky) return;
      var first = null;
      for (var i = 0; i < cards.length; i++) {
        if (!cards[i].hasAttribute('data-soon')) { first = cards[i]; break; }
      }
      if (!first) first = cards[0];
      if (!first) return;
      var name = first.getAttribute('data-name') || '';
      var km = first.getAttribute('data-km');
      var st = first.querySelector('[data-sf-hours]');
      sticky.querySelector('.sf-st-sticky-name').textContent = name + (km ? ' · ' + km + ' km' : '');
      sticky.querySelector('.sf-st-sticky-sub').textContent = st ? st.textContent : '';
      var view = sticky.querySelector('[data-sticky-view]');
      var route = sticky.querySelector('[data-sticky-route]');
      if (view) view.setAttribute('href', first.getAttribute('data-url') || '#');
      if (route) route.setAttribute('href', first.getAttribute('data-route') || '#');
    }

    var form = root.querySelector('[data-sf-postcode]');
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var q = form.querySelector('input').value.trim();
        if (!q) return;
        fetch('https://api.pdok.nl/bzk/locatieserver/search/v3_1/free?rows=1&q=' + encodeURIComponent(q))
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var doc = data && data.response && data.response.docs && data.response.docs[0];
            if (!doc || !doc.centroide_ll) return;
            var m = doc.centroide_ll.match(/POINT\(([\d.]+) ([\d.]+)\)/);
            if (m) sortByOrigin({ lng: parseFloat(m[1]), lat: parseFloat(m[2]) });
          })
          .catch(function () {});
      });
    }
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(function (pos) {
        sortByOrigin({ lat: pos.coords.latitude, lng: pos.coords.longitude });
      }, function () {}, { maximumAge: 600000, timeout: 6000 });
    }
    fillSticky();
    initSticky(root, sticky);
  }

  function initDetail() {
    var root = document.querySelector('[data-sf-studio]');
    if (!root) return;
    initSticky(root, root.querySelector('.sf-st-sticky'));
  }

  /* Markeer de pagina zolang de balk in beeld staat, zodat een chatbubbel
     erboven kan schuiven in plaats van eroverheen. */
  function setSticky(sticky, on) {
    sticky.classList.toggle('visible', on);
    document.body.classList.toggle('sf-sticky-on', on);
  }

  function initSticky(root, sticky) {
    if (!sticky) return;
    var marker = root.querySelector('[data-sticky-after]') || root;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        setSticky(sticky, !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0);
      }).observe(marker);
    } else {
      setSticky(sticky, true);
    }
  }

  function init() {
    applyStatus(document);
    initOverview();
    initDetail();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
